import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recommend-patient',
  templateUrl: './recommend-patient.component.html',
  styleUrls: ['./recommend-patient.component.css']
})
export class RecommendPatientComponent implements OnInit {

  constructor(private router : Router, private cookie:CookieService) { }

  ngOnInit(): void {
    this.cookie.deleteAll();
    localStorage.clear();
  }
  gotoHome(){
    this.router.navigateByUrl('/login');
  }

}
